import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectItems } from "../../../features/cart/cartSlice";
import BreadCrumbs from "../../../components/BreadCrumbs/BreadCrumbs";
import { Container } from "react-bootstrap";
import { RiGiftFill } from "react-icons/ri";
import yokohama from "../../../assets/images/TyreBrandLogos/yokohama_mini.png";
import serviceSampleImage from "../../../assets/images/serviceSampleImage.png";
import { selectCity } from "../../../redux/citySlice";
import { useLocation } from "react-router-dom";
import { Tooltip } from "primereact/tooltip";
import {
  CiClock2,
  CiLocationArrow1,
  CiLocationOn,
  CiSquarePlus,
} from "react-icons/ci";
import { useNavigate } from "react-router-dom";
import { Image } from "primereact/image";
import addMorePlus from "../../../assets/images/add-more-plus.png";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { AutoComplete } from "primereact/autocomplete";
import locationPin from "../../../assets/images/location_pin.png";
import { Calendar } from "primereact/calendar";
import "./Cart.css";

import { CountryService } from "../../../service/CountryService";
import {
  MdDirections,
  MdDoNotDisturb,
  MdEdit,
  MdGpsFixed,
  MdLocationOn,
  MdOutlineCalendarMonth,
  MdOutlineKeyboardArrowDown,
  MdSchedule,
  MdSearch,
} from "react-icons/md";
import { StarPicker } from "react-star-picker";
import HorizontalDatePicker from "../../../components/HorizontalDatePicker/HorizontalDatePicker";
import { InputText } from "primereact/inputtext";
import useCartAPI from "../../../api/useCartAPI";
import useHeroAPI from "../../../api/useHeroAPI";
import usePreDefinedListAPI from "../../../api/usePreDefinedListAPI";
import { isWithinInterval } from "date-fns";
import { Dropdown } from "primereact/dropdown";
import { Toast } from "primereact/toast";
import {
  updateCartQuantity,
  removeFromCart,
  setCartItems,
} from "../../../features/cart/cartSlice"; // Adjust the path as necessary
import { setLoading } from "../../../redux/loadingSlice";
import noProductFoundImage from "../../../assets/images/product-not-found.png";
import { refreshProductList } from "../../../redux/productSlice";
import AppSkeleton from "../../AppSkeleton/AppSkeleton";

interface Product {
  id?: string;
  prodImg?: string;
  prodName?: string;
  prodModel?: string;
  prodPrice?: string;
  quantity?: number;
  prodCompany?: string;
  prodStar?: string;
  prodReviewCount?: string;
  prodBestSeller?: boolean;
  prodBrand?: string;
  // Add more properties as needed
}
interface CartState {
  items: Product[];
}

interface RootState {
  cart: CartState;
}

// interface CartSummary {
//   subtotal: number;
//   gst: number;
//   total: number;
//   FITMENT: number;
//   ORGINAL_PLATFORM_CHARGE: number;
//   PLATFORM_CHARGE: number;
// }
interface CartSummary {
  subtotal: number;
  gst: number;
  product_total: number;
  total: number;
  discount: number;
  total_sum: number;

  additional_charges_summary?: {
    PLATFORM_CHARGE?: number;
    ORGINAL_PLATFORM_CHARGE?: number;
    FITMENT?: number;
    ORGINAL_FITMENT?: number;
    total_additional_charges?: number;
    orginal_amount?: number;
    FITMENT_DESC?: string;
    PLATFORM_CHARGE_DESC?: string;
  };
}
interface UserLocation {
  latitude: number;
  longitude: number;
}

const shouldShowPriceForUser = (authTokens: any) => {
  return authTokens?.user?.is_show_price === true;
};
const Cart = () => {
  const basePath = process.env.REACT_APP_BASE_PATH;

  const isShowPriceVar = "is_show_price";
  const roleCorporateAdmin = "ROLE_CORPORATE_ADMIN";
  const roleCorporateUser = "ROLE_CORPORATE_USER";
  const selectedCity = useSelector(selectCity);
  // console.log(selectedCity);
  const City = localStorage.getItem("selectedCity");
  const { predefinedFunc } = useHeroAPI();
  const { getServicePointList } = usePreDefinedListAPI();
  const {
    cartList,
    cartRemoveItem,
    cartSave,
    cartReduceItem,
    cartSummery,
    cartCount,
    moveToWishlist,
  } = useCartAPI();

  const toast = useRef<Toast>(null) as any;

  const dispatch = useDispatch();
  const loading = useSelector((state: any) => state.loading);

  const [userId, setUserId] = useState(null) as any;
  const [userRole, setUserRole] = useState(null) as any;
  const [products, setProducts] = useState<Product[]>([]);
  const [product, setProduct] = useState([]) as any;
  // const [products, setProducts] = useState([]);
  // const [servicePoints, setServicePoints] = useState([]) as any;
  const [cartLoaded, setCartLoaded] = useState(false);
  const [location, setLocation] = useState("Fetching location...");
  // const [cartSummary, setCartSummary] = useState<CartSummary>({
  //   subtotal: 0,
  //   gst: 0,
  //   total: 0,
  //   FITMENT: 0,
  //   ORGINAL_FITMENT: 0,
  //   ORGINAL_PLATFORM_CHARGE: 0,
  // });
  const [cartSummary, setCartSummary] = useState<CartSummary>({
    subtotal: 0,
    gst: 0,
    product_total: 0,
    total: 0,
    discount: 0,
    total_sum: 0,
    additional_charges_summary: {
      FITMENT: 0,
      ORGINAL_FITMENT: 0,
      PLATFORM_CHARGE: 0,
      ORGINAL_PLATFORM_CHARGE: 0,
    },
  });
  const [userLocation, setUserLocation] = useState<UserLocation | null>(() => {
    const lat = localStorage.getItem("latitude");
    const lng = localStorage.getItem("longitude");
    if (lat && lng) {
      return { latitude: parseFloat(lat), longitude: parseFloat(lng) };
    }
    return null;
  });
  const [selectedServicePointData, setSelectedServicePointData] = useState(
    [],
  ) as any;

  const [pickedDateState, setPickedDateState] = useState(null) as any;
  const [pickedTime, setPickedTime] = useState(null) as any;
  const [pickedTimeOptions, setPickedTimeOptions] = useState(null) as any;
  const [pickedTimeState, setPickedTimeState] = useState(null);
  const [isProceeding, setIsProceeding] = useState(false);
  const [city, setCity] = useState([]) as any;
  // const [selectedServicePoint, setSelectedServicePoint] = useState(null) as any;
  // const [selectedServicePoint, setSelectedServicePoint] = useState<any>(() => {
  //   const savedLocation = localStorage.getItem("locationM");
  //   if (savedLocation) {
  //     const cityName = savedLocation.includes("-")
  //       ? savedLocation.split("-")[0].trim()
  //       : savedLocation;
  //     return { name: cityName };
  //   }
  //   return null;
  // });
  const [selectedServicePoint, setSelectedServicePoint] = useState<any>(() => {
    // locationM is ALWAYS English and used for DB matching
    const savedLocation = localStorage.getItem("locationM");

    if (savedLocation) {
      return { name: savedLocation.trim() };
    }

    return null;
  });
  const [filteredServicePoint, setFilteredServicePoint] = useState(null) as any;
  const [isLocationSelected, setIsLocationSelected] = useState(false);
  const [isSchedulingAppointment, setIsSchedulingAppointment] = useState(false);
  const [selectedDate, setSelectedDate] = useState<Date>(new Date());
  const [specialInstructions, setSpecialInstructions] = useState("");
  const [visible, setVisible] = useState(false);
  const [rawServicePoints, setRawServicePoints] = useState<any[]>([]);
  const [isShowPrice, setIsShowPrice] = useState(false) as any;
  // const [userLocation, setUserLocation] = useState<UserLocation | null>(null);
  const [buttonLoader, setButtonLoader] = useState(false);
  const Location = useLocation();
  useEffect(() => {
    if (Location.state?.buyNow && products.length > 0 && cartLoaded) {
      proceedFunc();
    }
  }, [products, cartLoaded]);

  const fetchCartProducts = async () => {
    dispatch(setLoading(true));
    try {
      const payload = {
        user_id: userId,
        is_wishList: false,
      };

      const cartResponse: any = await cartList(payload);
      // console.log(cartResponse, "shubham>>>>>>>>>>>>>>>>>>>>>>>>>>");
      const countResponse: any = await cartCount(payload);
      // console.log("nautiyal>>>>>>>>>>>>>>>", countResponse);
      if (cartResponse?.status === 200) {
        const mappedProducts = cartResponse?.data?.data?.map((item: any) => ({
          id: String(item?.product_id ?? item?.service_id) ?? 0,
          prodImg:
            item?.product?.document_as_product?.length > 0
              ? item?.product?.document_as_product[0]?.document?.file_path
              : "https://mechmiles.com/not-available.png",
          prodName:
            item?.product?.product_name ??
            item?.service?.service_name ??
            "Not Available",
          prodPrice: String(item?.total_amount) ?? 0,
          quantity: item?.item_quantity ?? 0,
          prodBrand: item?.service_id ? null : item?.product?.brand?.thumbnail,
          prodTotal: String(item?.total_amount * item?.item_quantity) ?? 0,
          cartItemId: item?.cart_item_id ?? 0,
          variantName: item?.vehicle?.variant?.name,
          category: item?.product?.category?.code,
          prodBrandName: item?.product?.brand?.name,
        }));
        setProducts(mappedProducts);
        // dispatch(setLoading(false));
        const reduxCartItems = cartResponse?.data?.data?.map((item: any) => ({
          product_id: item?.product_id,
          cart_item_id: item?.cart_item_id,
        }));
        dispatch(setCartItems(reduxCartItems));
      } else {
        dispatch(setLoading(false));
      }
      if (countResponse.status === 200) {
        dispatch(updateCartQuantity(countResponse?.data?.count));
      }
      setCartLoaded(true);
    } finally {
      setCartLoaded(true);
      dispatch(setLoading(false));
    }
  };
  const getStartTimeInMinutes = (timeRange: string) => {
    let startTime = timeRange.split("-")[0].trim().replace(".", ":");

    const [time, period] = startTime.split(" ");
    let [hours, minutes] = time.split(":").map(Number);

    if (period === "PM" && hours !== 12) hours += 12;
    if (period === "AM" && hours === 12) hours = 0;

    return hours * 60 + minutes;
  };
  const fetchPredefined = async () => {
    const predefinedParentPayload = {
      entity_type: "CITY",
    };
    const predefinedTimePayload = {
      entity_type: "TIME",
    };
    const predefinedCityResponse = await predefinedFunc(
      predefinedParentPayload,
    );
    const predefinedTimeResponse = await predefinedFunc(predefinedTimePayload);

    const predefineTIme = predefinedTimeResponse?.data?.data
      .map((child: any) => {
        return {
          name: child.name,
          code: child.predefined_id,
        };
      })
      ?.sort(
        (a: any, b: any) =>
          getStartTimeInMinutes(a.name) - getStartTimeInMinutes(b.name),
      );

    if (predefinedCityResponse.status === 200) {
      setCity(predefinedCityResponse?.data?.data);
    }
    if (predefinedTimeResponse.status === 200) {
      // console.log("predefineTIme", predefineTIme);
      setPickedTimeOptions(predefineTIme);
    }
  };
  const calculateDistance = (
    lat1: number,
    lng1: number,
    lat2: number,
    lng2: number,
  ) => {
    const R = 6371;
    const dLat = ((lat2 - lat1) * Math.PI) / 180;
    const dLng = ((lng2 - lng1) * Math.PI) / 180;
    const a =
      Math.sin(dLat / 2) ** 2 +
      Math.cos((lat1 * Math.PI) / 180) *
        Math.cos((lat2 * Math.PI) / 180) *
        Math.sin(dLng / 2) ** 2;
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  };
  const fetchServicePoints = async (predefined_id: any) => {
    setButtonLoader(true);
    const payload = {
      city_id: predefined_id,
      lat: userLocation?.latitude,
      lng: userLocation?.longitude,
       flag:"website",
    };
    const response: any = await getServicePointList(payload, "", "");
    if (response.status === 200) {
      setRawServicePoints(response.data || []);
    }
    setButtonLoader(false);
  };
  const servicePoints = React.useMemo(() => {
    if (!rawServicePoints.length) return [];

    const userLat = userLocation?.latitude;
    const userLng = userLocation?.longitude;

    if (!userLat || !userLng) return rawServicePoints;

    return rawServicePoints
      .map((sp: any) => {
        const storeLat = parseFloat(sp.lat);
        const storeLng = parseFloat(sp.lng);
        if (Number.isNaN(storeLat) || Number.isNaN(storeLng)) {
          return { ...sp, distance: Infinity };
        }
        return {
          ...sp,
          distance: calculateDistance(userLat, userLng, storeLat, storeLng),
        };
      })
      .sort((a: any, b: any) => a.distance - b.distance);
  }, [rawServicePoints, userLocation]);
  const fetchCartSummary = async () => {
    const response: any = await cartSummery(null, null);
    if (response.status === 200) {
      setCartSummary(response?.data);
      // dispatch(setLoading(false));
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);

    dispatch(setLoading(true));
  }, [dispatch]);

  useEffect(() => {
    fetchCartSummary();
  }, [products]);

  useEffect(() => {
    const authTokens = JSON.parse(localStorage.getItem("authTokens") || "{}");
    const currentUserId = authTokens?.user?.id;
    const currentUserRole = authTokens?.user?.roles?.[0]?.code ?? null;

    setUserId(currentUserId);
    setUserRole(currentUserRole);
    setIsShowPrice(shouldShowPriceForUser(authTokens));

    if (currentUserId) {
      fetchCartProducts();
      fetchPredefined();
    }

    setCartLoaded(true);
  }, []);
  // useEffect(() => {
  //   setProducts(staticProducts);
  //   setCartLoaded(true);
  //   setIsShowPrice(true); // if you want prices visible
  // }, []);
  const fetchUserLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setUserLocation({ latitude, longitude });
          // You can also fetch service points based on this location here
        },
        (error) => {
          console.error("Error Code = " + error.code + " - " + error.message);
          // Handle location error (User denied location access, etc.)
        },
      );
    } else {
      console.log("Geolocation is not supported by this browser.");
      // Handle case where the browser doesn't support Geolocation
    }
  };

  useEffect(() => {
    fetchUserLocation();
    // Other initialization code...
  }, []);

  const panelFooterTemplate = () => {
    const isServicePointSelected = (filteredServicePoint || []).some(
      (servicePoint: any) => servicePoint["name"] === selectedServicePoint,
    );
    return (
      <div className="py-2 px-3">
        {isServicePointSelected ? (
          <span>
            <b>{selectedServicePoint}</b> selected.
          </span>
        ) : (
          "No Service Point is Selected."
        )}
      </div>
    );
  };

  const search = (event: any) => {
    setTimeout(() => {
      let _filteredServicePoint: any;

      if (!event.query.trim().length) {
        _filteredServicePoint = [...city];
      } else {
        _filteredServicePoint = city.filter((country: any) => {
          return country.name
            .toLowerCase()
            .startsWith(event.query.toLowerCase());
        });
      }

      setFilteredServicePoint(_filteredServicePoint);
    }, 250);
  };

  const itemTemplate = (item: any) => {
    return (
      <div className="auto-complete-text-wrapper">
        <div className="auto-complete-container">
          <Image
            alt={item.name}
            src={locationPin}
            className={`auto-complete-pin-img `}
            // style={{ width: "26px" }}
          />
          <div>{item.name}</div>
        </div>
        <hr />
      </div>
    );
  };

  const gotoSummary = () => {
    setIsProceeding(false);

    const pickedTimeVar: any = pickedTimeOptions.find(
      (time: any) => time.code === pickedTime,
    );

    navigate(`${basePath}summary`, {
      state: {
        selectedServicePointData,
        pickedDateState,
        pickedTimeVar,
        specialInstructions,
      },
    });
  };

  const footerContent = (
    <div className="select-location-footer">
      <Button
        label="Cancel"
        onClick={() => setIsProceeding(false)}
        className="p-button-text select-location-footer-cancel"
      />
      <Button
        label="Confirm Booking"
        onClick={() => gotoSummary()}
        autoFocus
        disabled={!pickedTime || !pickedDateState}
        className="select-location-footer-confirm"
      />
    </div>
  );

  const cartItems = useSelector((state: RootState) => state.cart.items);

  const navigate = useNavigate();
  // console.log("basepath Shubham>>>>>>>>>>>>", basePath);
  const redirectToHome = () => {
    // console.log(`${basePath}products`);
    navigate(`${basePath}products`, {
      state: {
        code: "TYRE",
        tyreType: { code: "CAR" },
      },
    });
  };

  const increaseQuantity = async (id: string) => {
    const selectedProduct: any = products.find(
      (product: any) => product.id === id,
    );

    if (
      selectedProduct &&
      selectedProduct.quantity >= 2 &&
      (userRole === roleCorporateAdmin || userRole === roleCorporateUser)
    ) {
      toast?.current?.show({
        severity: "info",
        summary: "Quantity Limit",
        detail: "You cannot add more than 2 quantities of a single item.",
        life: 3000,
      });
      return;
    }
    const payload = {
      product_id: id,
      item_quantity: 1,
      is_wishList: false,
    };

    const response: any = await cartSave(payload);

    if (response.status === 201) {
      setProducts((prevProducts) =>
        prevProducts.map((product: any) =>
          product.id === id
            ? {
                ...product,
                quantity: (product.quantity ?? 1) + 1,
                prodTotal: (
                  parseInt(product.prodTotal) + parseInt(product.prodPrice)
                ).toString(),
              }
            : product,
        ),
      );
    }
  };

  const decreaseQuantity = async (id: number, cartItemId: string) => {
    const selectedProduct: any = products.find(
      (product: any) => product.id === id,
    );
    if (selectedProduct && selectedProduct.quantity <= 1) {
      handleRemoveItem(null, selectedProduct);
      return;
    }

    const payload = {
      cart_item_id: cartItemId,
    };

    const response: any = await cartReduceItem(payload);

    if (response.status === 200) {
      setProducts((prevProducts) =>
        prevProducts.map((product: any) =>
          product.id === id && (product.quantity ?? 1) > 1
            ? {
                ...product,
                quantity: (product.quantity ?? 1) - 1,
                prodTotal: (
                  parseInt(product.prodTotal) - parseInt(product.prodPrice)
                ).toString(),
              }
            : product,
        ),
      );
    }
  };
  const proceedFunc = () => {
    // Always English
    const cityName = localStorage.getItem("locationM")?.trim() || "";

    const matchedCity = city.find(
      (item: any) => item.name.toLowerCase().trim() === cityName.toLowerCase(),
    );

    setIsProceeding(true);

    if (matchedCity) {
      setSelectedServicePoint(matchedCity);
      setIsLocationSelected(true);

      fetchServicePoints(matchedCity.predefined_id);
    }
  };
  // const proceedFunc = () => {
  //   const location = localStorage.getItem("locationM");
  //   console.log(location, "location1");
  //   let cityName = "";

  //   if (location && location.includes("-")) {
  //     console.log("location2");
  //     cityName = location.split("-")[0].trim();
  //   } else if (location) {
  //     console.log("location3");
  //     cityName = location;
  //   }

  //   const matchedCity = city.find(
  //     (item: any) => item.name.toLowerCase() === cityName.toLowerCase(),
  //   );
  //   console.log(location, "location4");

  //   setIsProceeding(true);

  //   if (matchedCity) {
  //     setSelectedServicePoint(matchedCity);
  //     setIsLocationSelected(true);

  //     fetchServicePoints(matchedCity.predefined_id);
  //   }
  //   console.log("location5");
  // };

  const handleLocationSelect = (e: any) => {
    setSelectedServicePoint(e.value);
    if (typeof e.value === "object") {
      setIsLocationSelected(true);
    }
    console.log("isLocationSelected<<<<<<<<<<<<<", isLocationSelected);
  };

  const handleRemoveLocation = () => {
    setSelectedServicePoint(null);
    setIsLocationSelected(false);
    setIsSchedulingAppointment(false);
    setPickedDateState(null);
    setRawServicePoints([]);
  };

  const handleScheduleAppointment = (e: any, servicePoint: any) => {
    e.preventDefault();
    setSelectedServicePointData([servicePoint]);
    setIsSchedulingAppointment(true);
  };

  const handleLocationChange = () => {
    setIsSchedulingAppointment(false);
    setPickedDateState(null);
  };

  const removeItemFunc = async () => {
    const response: any = await cartRemoveItem(product?.cartItemId);

    //   if (response.status === 200) {
    //     fetchCartProducts();
    //     const newCartQuantity = products.length;

    //     dispatch(updateCartQuantity(newCartQuantity));
    //     setVisible(false);
    //     return toast?.current?.show({
    if (response.status === 200) {
      dispatch(removeFromCart(Number(product.id)));

      fetchCartProducts();

      const newCartQuantity = products.length - 1;

      dispatch(updateCartQuantity(newCartQuantity));

      setVisible(false);

      return toast?.current?.show({
        severity: "success",
        summary: "Successful",
        detail: `${response?.data?.message}`,
      });
    } else {
      return toast?.current?.show({
        severity: "error",
        summary: "Failed",
        detail: `Failed to remove item from cart`,
      });
    }
  };

  const handleRemoveItem = async (e: any, product: any) => {
    setProduct(product);
    setVisible(true);
  };

  const handleLocationSelection = async (e: any) => {
    fetchServicePoints(e.value.predefined_id);
  };

  const handleTimeChange = (e: any) => {
    setPickedTime(e.value);
  };

  const confirmDeleteFooter = (
    <div>
      <Button
        label="No"
        icon="pi pi-times"
        onClick={() => setVisible(false)}
        className="p-button-text"
      />
      <Button
        label="Yes"
        icon="pi pi-check"
        onClick={removeItemFunc}
        autoFocus
        className="p-button-text"
        style={{
          backgroundColor: "#642088 ",
          color: "#fff",
          borderRadius: "10px",
        }}
      />
    </div>
  );

  const getDirectionFunc = (lat: any, lng: any) => {
    const url = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;
    const link = document.createElement("a");
    link.href = url;
    link.target = "_blank";
    link.rel = "noopener noreferrer";

    // Simulate a click on the link
    document.body.appendChild(link);
    link.click();

    // Clean up the DOM
    document.body.removeChild(link);
  };

  const moveToWishListFunc = async (product: any) => {
    const payload = {
      cart_item_id: product.cartItemId,
    };

    const response: any = await moveToWishlist(payload);
    if (response.status === 200) {
      fetchCartProducts();
      const newCartQuantity = products.length;

      dispatch(updateCartQuantity(newCartQuantity));
      // dispatch(addToProduct(product));
      // dispatch(refreshProductList());
      return toast?.current?.show({
        severity: "success",
        summary: "Success",
        detail: `Added to wishlist`,
      });
    }
  };
  const fetchCurrentLocation = async (manually = false) => {
    if (!navigator.geolocation) {
      setLocation("Geolocation is not supported by this browser.");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;

        setUserLocation({ latitude, longitude });

        localStorage.setItem("latitude", String(latitude));
        localStorage.setItem("longitude", String(longitude));

        try {
          // User's preferred browser language
          const preferredLanguage = navigator.language || "en";

          // ==========================================
          // API 1: ALWAYS ENGLISH
          // Used for localStorage, DB and filtering
          // ==========================================
          const englishResponse = await fetch(
            `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&language=en&key=AIzaSyDj9D7Sm1MLG1y4CimROoQu1SSUl4OnHyI`,
          );

          const englishData = await englishResponse.json();

          // ==========================================
          // API 2: USER LANGUAGE
          // Used only for UI display
          // ==========================================
          const displayResponse = await fetch(
            `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&language=${preferredLanguage}&key=AIzaSyDj9D7Sm1MLG1y4CimROoQu1SSUl4OnHyI`,
          );

          const displayData = await displayResponse.json();

          if (englishData.results?.[0] && displayData.results?.[0]) {
            // ==========================================
            // GET ENGLISH CITY
            // ==========================================
            const englishAddressComponents =
              englishData.results[0].address_components;

            const englishLocalityComponent = englishAddressComponents.find(
              (component: { types: string | string[] }) =>
                component.types.includes("locality"),
            );

            const englishPostalCodeComponent = englishAddressComponents.find(
              (component: { types: string | string[] }) =>
                component.types.includes("postal_code"),
            );

            const englishCity = englishLocalityComponent?.short_name || "";

            const postalCode = englishPostalCodeComponent?.short_name || "";

            // ==========================================
            // GET DISPLAY CITY
            // Hindi for Hindi preference
            // English otherwise
            // ==========================================
            const displayAddressComponents =
              displayData.results[0].address_components;

            const displayLocalityComponent = displayAddressComponents.find(
              (component: { types: string | string[] }) =>
                component.types.includes("locality"),
            );

            const displayCity =
              displayLocalityComponent?.short_name || englishCity;

            const displayLocation = postalCode
              ? `${displayCity} - ${postalCode}`
              : displayCity;

            // ==========================================
            // UI ONLY
            // ==========================================
            setLocation(displayLocation);

            // ==========================================
            // ALWAYS ENGLISH FOR SEARCH/FILTER
            // ==========================================
            localStorage.setItem("locationM", englishCity);

            // Localized value only for UI
            localStorage.setItem("displayLocationM", displayLocation);
          } else {
            console.warn("No results found");

            setLocation("Select Location - Unknown Pincode");

            localStorage.removeItem("locationM");
            localStorage.removeItem("displayLocationM");
          }
        } catch (error) {
          console.error("Error fetching address:", error);

          setLocation("Error retrieving location.");
        }
      },

      (error) => {
        console.error("Error getting location:", error);

        setLocation("Unable to retrieve location.");

        if (manually) {
          alert("Please enable location access.");
        }
      },
    );
  };
  useEffect(() => {
    fetchCurrentLocation();
  }, []);
  const handleCurrentLocation = () => {
    // locationM is always English
    const cityName = localStorage.getItem("locationM")?.trim() || "";

    const matchedCity = city.find(
      (item: any) => item.name.toLowerCase().trim() === cityName.toLowerCase(),
    );

    if (matchedCity) {
      setSelectedServicePoint(matchedCity);
      setIsLocationSelected(true);

      fetchServicePoints(matchedCity.predefined_id);
    }
  };

  useEffect(() => {
    if (!city.length || isLocationSelected) return;

    // locationM is always English
    const cityName = localStorage.getItem("locationM")?.trim() || "";

    if (!cityName) return;

    const matchedCity = city.find(
      (item: any) => item.name.toLowerCase().trim() === cityName.toLowerCase(),
    );

    if (matchedCity) {
      setSelectedServicePoint(matchedCity);
      setIsLocationSelected(true);

      fetchServicePoints(matchedCity.predefined_id);
    }
  }, [city]);

  const handleDateSelect = (date: Date) => {
    const selected = new Date(date);
    selected.setHours(0, 0, 0, 0);

    const start = new Date();
    start.setHours(0, 0, 0, 0);

    const end = new Date(start);
    end.setDate(start.getDate() + 5);

    if (
      isWithinInterval(selected, {
        start,
        end,
      })
    ) {
      setPickedDateState(selected);
      setPickedTime(null); // Reset time when date changes
    }
  };
  const getTimeInMinutes = (timeRange: string) => {
    const startTime = timeRange.split("-")[0].trim().replace(".", ":");

    const [time, period] = startTime.split(" ");
    let [hours, minutes] = time.split(":").map(Number);

    if (period === "PM" && hours !== 12) hours += 12;
    if (period === "AM" && hours === 12) hours = 0;

    return hours * 60 + minutes;
  };
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const maxDate = new Date(today);
  maxDate.setDate(today.getDate() + 5); // Total 5 days including today

  const filteredTimeOptions = React.useMemo(() => {
    if (!pickedTimeOptions) return [];

    if (!pickedDateState) return pickedTimeOptions;

    const selectedDate = new Date(pickedDateState);

    const isToday =
      selectedDate.getDate() === today.getDate() &&
      selectedDate.getMonth() === today.getMonth() &&
      selectedDate.getFullYear() === today.getFullYear();

    if (!isToday) return pickedTimeOptions;

    const now = new Date();
    const currentMinutes = now.getHours() * 60 + now.getMinutes();

    return pickedTimeOptions.filter(
      (item: any) => getTimeInMinutes(item.name) > currentMinutes,
    );
  }, [pickedDateState, pickedTimeOptions]);
  if (loading) {
    return (
      <AppSkeleton
        count={2}
        width="450px"
        height="300px"
        borderRadius="12px"
        containerClassName="popular-brands-skeleton-grid"
        className="popular-brands-skeleton-item"
      />
    );
  }
  const displayLocationName =
    selectedServicePoint?.name ||
    localStorage.getItem("displayLocationM")?.split("-")[0].trim() ||
    "";
  return (
    <>
      <Toast ref={toast} />
      <div className="cart-wrapper">
        <Container>
          <div className="cart-header-wrapper">
            <div className="breadcrumbs-wrapper">
              <BreadCrumbs />
            </div>
            <div className="cart-title">Items in your cart</div>
          </div>

          <div className="cart-products-price-wrapper">
            <div className="cart-products-wrapper">
              {cartLoaded && !loading && products.length === 0 && (
                <div className="no-products">
                  <Image
                    src={noProductFoundImage}
                    alt="No Product Found"
                    // width={"100"}
                    // height={"200"}
                    className="no-products-image"
                  />

                  <div className="no-products-text">No Products in Cart</div>
                </div>
              )}

              {products.map((product: any) => (
                <div className="cartCard" key={product.id}>
                  <div className="cartCardImageSection">
                    <div className="cartImageCard">
                      <Image
                        src={product.prodImg}
                        alt={product.prodName}
                        // className="cartTyreImage"
                        className={
                          ["TRUCK", "CAR", "TWO-WHEELER"].includes(
                            product?.category,
                          )
                            ? "cartTyreImage vehicleTyreImage"
                            : "cartTyreImage"
                        }
                      />
                    </div>
                  </div>

                  <div className="cartCardContent">
                    <div className="cartActionIcons">
                      <i
                        className="pi pi-heart"
                        onClick={() => moveToWishListFunc(product)}
                      />

                      <i
                        className="pi pi-trash"
                        onClick={(e: any) => handleRemoveItem(e, product)}
                      />
                    </div>

                    {/* <div style={{ width: "100%" }}> */}
                    <p className="cartBrandLogo">{product.prodBrandName}</p>
                    {/* </div> */}

                    <div className="contentbox">
                      <div className="cartTyreName">{product?.prodName}</div>

                      <div className="cartVehicleName">
                        {product?.variantName}
                      </div>

                      {/* <div className="cartModelName">{product?.prodModel}</div> */}
                      <div className="cartHeadingLabel">Price</div>
                      <div className="cartProductPrice">
                        ₹ {isShowPrice ? product.prodPrice : "***"}
                      </div>
                    </div>

                    <div className="cartBottomSection">
                      <div className="cartQtySection">
                        <div className="cartHeadingLabel1 ">Quantity</div>

                        <div className="cartQtyControl">
                          <button
                            onClick={() =>
                              decreaseQuantity(product.id, product.cartItemId)
                            }
                          >
                            -
                          </button>

                          <span>{product.quantity}</span>

                          <button onClick={() => increaseQuantity(product.id)}>
                            +
                          </button>
                        </div>
                      </div>

                      <div className="cartTotalSection">
                        <div className="cartHeadingLabel">Total</div>

                        <div className="cartTotalPrice">
                          ₹ {isShowPrice ? product.prodTotal : "***"}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
              <Button className="add-more-button" onClick={redirectToHome}>
                <Image
                  src={addMorePlus}
                  alt="Add more plus Icon"
                  className="add-more-plus"
                />
                Add more items
              </Button>
            </div>
            <div className="cart-price-container">
              <div className="cart-price-wrapper">
                <div className="cart-summary-card">
                  {/* {isShowPrice ? */}
                  <div>
                    <div className="cart-summary-title">Cart Summary</div>
                    {[cartSummary].map((summary: any) => {
                      return (
                        // <div className="cart-summary-details">
                        //   <div className="cart-summary-row">
                        //     <span className="cart-summary-label">Subtotal</span>
                        //     <span className="cart-summary-value">
                        //       &#8377; {isShowPrice ? summary?.subtotal : `***`}
                        //     </span>
                        //   </div>
                        //   <div className="cart-summary-row">
                        //     <span className="cart-summary-label">GST</span>
                        //     <span className="cart-summary-value">
                        //       &#8377;{" "}
                        //       {isShowPrice
                        //         ? Number(summary?.gst).toFixed(2)
                        //         : `***`}
                        //     </span>
                        //   </div>
                        //   <div className="cart-summary-row">
                        //     <span className="cart-summary-label">FITMENT</span>
                        //     <span className="cart-summary-value">
                        //       &#8377;{" "}
                        //       {isShowPrice
                        //         ? Number(summary?.gst).toFixed(2)
                        //         : `***`}
                        //     </span>
                        //   </div>
                        //   <div className="cart-summary-row">
                        //     <span className="cart-summary-label">GST</span>
                        //     <span className="cart-summary-value">
                        //       &#8377;{" "}
                        //       {isShowPrice
                        //         ? Number(summary?.gst).toFixed(2)
                        //         : `***`}
                        //     </span>
                        //   </div>
                        //   <div className="cart-summary-row total">
                        //     <span className="cart-summary-label">Total</span>
                        //     <span className="cart-summary-value">
                        //       &#8377;{" "}
                        //       {isShowPrice
                        //         ? Number(summary?.total).toFixed(2)
                        //         : `***`}
                        //     </span>
                        //   </div>
                        // </div>
                        <div className="cart-summary-details">
                          {/* SUBTOTAL */}
                          <div className="cart-summary-row">
                            <span className="cart-summary-label">Subtotal</span>

                            <span className="cart-summary-value">
                              ₹ {isShowPrice ? summary?.product_total : "***"}
                            </span>
                          </div>

                          {/* GST */}
                          {/* <div className="cart-summary-row">
                            <span className="cart-summary-label">GST</span>

                            <span className="cart-summary-value">
                              ₹{" "}
                              {isShowPrice
                                ? Number(summary?.gst ?? 0).toFixed(2)
                                : "***"}
                            </span>
                          </div> */}

                          {/* FITMENT - SHOW ONLY IF API RETURNS IT */}
                          {/* {summary?.FITMENT !== undefined &&
                            summary?.FITMENT !== null && (
                              <div className="cart-summary-row">
                                <span className="cart-summary-label">
                                  <span
                                    className="summary-tooltip-label"
                                    data-pr-tooltip="Fitment charges are applicable for the selected service."
                                  >
                                    FITMENT
                                    <i className="pi pi-info-circle summary-info-icon" />
                                  </span>

                                  <Tooltip target=".summary-tooltip-label" />
                                </span>

                                <span className="cart-summary-value">
                                  ₹{" "}
                                  {isShowPrice
                                    ? Number(summary?.FITMENT ?? 0).toFixed(2)
                                    : "***"}
                                </span>
                              </div>
                            )} */}
                          {/* FITMENT */}
                          {summary?.additional_charges_summary?.FITMENT !==
                            undefined &&
                            summary?.additional_charges_summary?.FITMENT !==
                              null && (
                              <div className="cart-summary-row">
                                <span className="cart-summary-label">
                                  {/* <span
                                    className="summary-tooltip-label"
                                    data-pr-tooltip="Fitment charges are applicable for the selected service."
                                  > */}
                                  <span
                                    className="summary-tooltip-label"
                                    data-pr-tooltip={
                                      summary?.additional_charges_summary
                                        ?.FITMENT_DESC || ""
                                    }
                                  >
                                    Fitment Charges
                                    <i className="pi pi-info-circle summary-info-icon" />
                                  </span>

                                  <Tooltip target=".summary-tooltip-label" />
                                </span>

                                {/* <span className="cart-summary-value">
                                  ₹{" "}
                                  {isShowPrice
                                    ? Number(
                                        summary?.additional_charges_summary
                                          ?.FITMENT ?? 0,
                                      ).toFixed(2)
                                    : "***"}
                                </span> */}
                                <span className="cart-summary-value platform-charge-value">
                                  {summary?.additional_charges_summary
                                    ?.ORGINAL_FITMENT >
                                    summary?.additional_charges_summary
                                      ?.FITMENT && (
                                    <span className="original-platform-charge">
                                      ₹{" "}
                                      {isShowPrice
                                        ? Number(
                                            summary?.additional_charges_summary
                                              ?.ORGINAL_FITMENT ?? 0,
                                          ).toFixed(2)
                                        : "***"}
                                    </span>
                                  )}
                                  ₹{" "}
                                  {isShowPrice
                                    ? Number(
                                        summary?.additional_charges_summary
                                          ?.FITMENT ?? 0,
                                      ).toFixed(2)
                                    : "***"}
                                </span>
                              </div>
                            )}
                          {summary?.additional_charges_summary
                            ?.PLATFORM_CHARGE !== undefined &&
                            summary?.additional_charges_summary
                              ?.PLATFORM_CHARGE !== null && (
                              <div className="cart-summary-row">
                                <span className="cart-summary-label">
                                  <span
                                    className="platform-charge-tooltip"
                                    data-pr-tooltip={
                                      summary?.additional_charges_summary
                                        ?.PLATFORM_CHARGE_DESC || ""
                                    }
                                  >
                                    Platform Fee
                                    <i className="pi pi-info-circle summary-info-icon" />
                                  </span>

                                  <Tooltip target=".platform-charge-tooltip" />
                                </span>

                                <span className="cart-summary-value platform-charge-value">
                                  {summary?.additional_charges_summary
                                    ?.ORGINAL_PLATFORM_CHARGE >
                                    summary?.additional_charges_summary
                                      ?.PLATFORM_CHARGE && (
                                    <span className="original-platform-charge">
                                      ₹{" "}
                                      {isShowPrice
                                        ? Number(
                                            summary?.additional_charges_summary
                                              ?.ORGINAL_PLATFORM_CHARGE ?? 0,
                                          ).toFixed(2)
                                        : "***"}
                                    </span>
                                  )}
                                  ₹{" "}
                                  {isShowPrice
                                    ? Number(
                                        summary?.additional_charges_summary
                                          ?.PLATFORM_CHARGE ?? 0,
                                      ).toFixed(2)
                                    : "***"}
                                </span>
                              </div>
                            )}

                          {/* TOTAL */}
                          <div className="cart-summary-row total">
                            <span className="cart-summary-label">Total</span>

                            <span className="cart-summary-value">
                              ₹{" "}
                              {isShowPrice
                                ? Number(summary?.total ?? 0).toFixed(2)
                                : "***"}
                            </span>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  {/* : '' */}
                  {/* } */}
                </div>
              </div>
              {cartLoaded && products.length === 0 ? (
                <Button className="cart-summary-proceed-btn" disabled={true}>
                  Proceed
                </Button>
              ) : (
                <Button
                  className="cart-summary-proceed-btn"
                  onClick={() => {
                    proceedFunc();
                  }}
                >
                  Proceed
                </Button>
              )}
            </div>
          </div>
        </Container>
      </div>
      {/* {cartItems.map((item) => (
        <div key={item.id}>
          <img src={item.prodImg} alt={item.prodName} />
          <h2>{item.prodName}</h2>
          <p>{item.prodModel}</p>
          <p>{item.prodPrice}</p>
        </div>
      ))} */}
      <Dialog
        header="Select a service point"
        visible={isProceeding}
        style={{ width: "70%" }}
        onHide={() => setIsProceeding(false)}
        footer={isSchedulingAppointment ? footerContent : ""}
        className="is-proceeding-header"
      >
        {isLocationSelected && !isSchedulingAppointment && (
          <div className="selected-location-container">
            <div className="selected-location-wrapper">
              <div className="selected-location">
                <MdLocationOn className="selected-location-icon cursor-pointer" />
                <span className="selected-location-text">
                  {/* {selectedServicePoint?.name} */}
                  {displayLocationName}
                </span>
              </div>
              {/* <p
                icon="pi pi-pencil"
                className="change-Location-button cursor-pointer"
                onClick={handleRemoveLocation}
              ></p> */}
              <p
                className="change-Location-button cursor-pointer"
                onClick={handleRemoveLocation}
              >
                <MdEdit />
              </p>
            </div>
            <div className="store-near-location-wrapper">
              <div className="store-near-location-title">
                Stores Near Your Location
              </div>
              {buttonLoader && !servicePoints ? (
                // <div className="loading-overlay">Loading...</div>
                <AppSkeleton
                  count={2}
                  width="300px"
                  height="300px"
                  borderRadius="12px"
                  containerClassName="popular-brands-skeleton-grid"
                  className="popular-brands-skeleton-item"
                />
              ) : null}
              <div className="store-near-location-list">
                {servicePoints.map((servicePoint: any, index: number) => (
                  <div className="service-point-card" key={index}>
                    <div className="service-point-name-wrapper">
                      <div className="service-point-name">
                        {servicePoint.service_point_name}
                      </div>
                      <div className="service-point-distance"></div>
                    </div>
                    <div className="service-point-meta-wrapper">
                      <div className="service-point-opens">
                        <CiClock2 />
                        {`Opens At ${
                          servicePoint.service_point_open_time || "Time"
                        }`}
                      </div>
                      <div className="service-point-address">
                        <CiLocationOn />
                        {servicePoint.service_point_address || "Address"}
                      </div>
                    </div>
                    {/* <div className="service-point-rating">
                      <StarPicker
                        value={parseInt(servicePoint.rating) || "2.5"}
                        halfStars
                        disabled={true}
                        size={15}
                      />
                      {servicePoint.rating || "0"}
                    </div> */}
                    <div className="service-point-actions">
                      <div className="service-point-actions-btns">
                        <Button
                          className="get-direction-button"
                          icon={
                            <CiLocationArrow1 style={{ fontSize: "16px" }} />
                          }
                          label="Get Direction"
                          onClick={() =>
                            getDirectionFunc(servicePoint.lat, servicePoint.lng)
                          }
                        />
                        <Button
                          className="schedule-appointment-button"
                          icon={
                            <MdOutlineCalendarMonth
                              style={{ fontSize: "16px" }}
                            />
                          }
                          label="Select Location"
                          onClick={(e) =>
                            handleScheduleAppointment(e, servicePoint)
                          } // Pass the servicePoint here
                        />
                      </div>
                      <div className="service-point-actions-img-container">
                        {servicePoint?.service_group?.image_url && (
                          <Image
                            src={servicePoint?.service_group?.image_url}
                            className="service-point-actions-img"
                          />
                        )}
                        {!servicePoint?.service_group?.image_url && (
                          <MdDoNotDisturb
                            style={{
                              height: "25px",
                              width: "25",
                              marginTop: "5px",
                            }}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
        {isLocationSelected && isSchedulingAppointment && (
          <div className="selected-location-container">
            <div className="selected-wrapper">
              <div className="selected-location-wrapper1">
                <div className="selected-location">
                  <MdLocationOn className="selected-location-icon" />
                  <span className="selected-location-text">
                    {selectedServicePoint?.name}
                  </span>
                </div>
                {/* <Button
                  icon="pi pi-pencil"
                  className="change-location-button"
                  onClick={handleRemoveLocation}
                >
                  
                </Button> */}
                <p
                  className="change-Location-button cursor-pointer"
                  onClick={handleRemoveLocation}
                >
                  <MdEdit />
                </p>
              </div>
              <div className="selected-store-info-wrapper">
                <div className="store-near-location-title">
                  Stores Near Your Location
                </div>
                <div className="store-near-location-list">
                  {selectedServicePointData.map(
                    (servicePoint: any, index: number) => (
                      <div
                        className="selected-store-point-wrapper"
                        style={{
                          boxShadow: "0px 0px 4px",
                          borderRadius: "7px",
                          padding: "7px 12px",
                        }}
                      >
                        <div className="store-point-info">
                          <div className="store-point-details">
                            <div className="store-point-name">
                              {servicePoint.service_point_name}
                            </div>
                            <div className="store-point-address">
                              {servicePoint.service_point_address ||
                                "Address Not Available"}
                            </div>
                          </div>
                        </div>
                        <div className="change-store-button-wrapper">
                          {/* <Button
                            icon="pi pi-pencil"
                            className="change-store-button"
                            onClick={handleLocationChange}
                          ></Button> */}
                          <p
                            className="change-Location-button  cursor-pointer"
                            onClick={handleLocationChange}
                          >
                            <MdEdit />
                          </p>
                        </div>
                      </div>
                    ),
                  )}
                </div>
              </div>
            </div>{" "}
            <div className="store-near-location-wrapper">
              <div className="store-near-location-wrapper">
                <div className="schedule-your-appointment-wrapper">
                  <div className="store-near-location-title">
                    Select your prefered date & time
                  </div>

                  <div className="schedule-your-appointment-container">
                    <div className="pick-a-date-wrapper width-50">
                      <div className="pick-a-date-title ">
                        Pick A Date
                        <Calendar
                          value={pickedDateState}
                          onChange={(e: any) => handleDateSelect(e.value)}
                          showIcon
                          className="pick-a-date-calendar"
                          placeholder="Select Manually"
                          minDate={today}
                          maxDate={maxDate}
                        />
                      </div>
                      <div className="horizontal-pick-a-date">
                        <HorizontalDatePicker
                          startDate={today}
                          endDate={maxDate}
                          onDateSelect={handleDateSelect}
                          externalSelectedDate={pickedDateState}
                        />
                      </div>
                    </div>
                    <div className="pick-a-time-wrapper width-50">
                      <div className="pick-a-time-title-wrapper">
                        <div className="pickTime">
                          <div className="store-near-location-title">
                            Pick A Time
                          </div>
                          <div>
                            <p
                              className=" mb-20"
                              style={{
                                marginTop: "4px",
                                fontSize: "10px",
                                fontWeight: "600",
                              }}
                            >
                              (The Mechmiles team will update you)
                            </p>
                          </div>
                        </div>
                        <div className="pick-a-time-calender-wrapper">
                          {/* <Dropdown
                            value={pickedTime}
                            onChange={(e) => handleTimeChange(e)}
                            options={pickedTimeOptions}
                            virtualScrollerOptions={{ itemSize: 38 }}
                            optionLabel="name"
                            optionValue="code"
                            placeholder="Select Item"
                            className="pick-a-time-dropdown w-full"
                          /> */}
                          <Dropdown
                            value={pickedTime}
                            onChange={handleTimeChange}
                            options={filteredTimeOptions}
                            virtualScrollerOptions={{ itemSize: 38 }}
                            optionLabel="name"
                            optionValue="code"
                            placeholder="Select Time"
                            className="pick-a-time-dropdown w-full"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="schedule-appointment-wrapper">
                      <div className="store-near-location-title">
                        Special Instructions
                      </div>
                      <InputText
                        value={specialInstructions}
                        onChange={(e: any) =>
                          setSpecialInstructions(e.target.value)
                        }
                        className="schedule-appointment-input"
                        placeholder="Enter Special Instruction"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {!isLocationSelected && (
          <span className="w-full">
            <AutoComplete
              field="name"
              value={selectedServicePoint}
              suggestions={filteredServicePoint}
              completeMethod={search}
              onChange={(e) => handleLocationSelect(e)}
              itemTemplate={itemTemplate}
              // panelFooterTemplate={panelFooterTemplate}
              className="service-point-auto-complete"
              placeholder="Enter a location"
              onSelect={(e) => handleLocationSelection(e)}
            />
            <div className="auto-complete-icons-wrapper p-input-icon-right">
              <MdSearch className="auto-complete-search-location cursor-pointer" />
              <MdGpsFixed
                className="auto-complete-choose-location cursor-pointer"
                onClick={() => handleCurrentLocation()}
              />
            </div>
          </span>
        )}
      </Dialog>
      <Dialog
        header="Confirm Remove"
        visible={visible}
        style={{ width: "50vw" }}
        onHide={() => setVisible(false)}
        footer={confirmDeleteFooter}
      >
        <p className="m-0">Are you sure you want to remove this cart item?</p>
      </Dialog>
    </>
  );
};

export default Cart;
